var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowDownCircle28(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5001 26C21.1276 26 26.5001 20.6274 26.5001 14C26.5001 7.37258 21.1276 2 14.5001 2C7.87273 2 2.50014 7.37258 2.50014 14C2.50014 20.6274 7.87273 26 14.5001 26ZM13.6163 20.7529C14.1044 21.241 14.8959 21.241 15.384 20.7529L19.6267 16.5102C20.1148 16.0221 20.1148 15.2306 19.6267 14.7425C19.1385 14.2543 18.3471 14.2543 17.8589 14.7425L15.7502 16.8512L15.7502 7.63606C15.7502 6.94571 15.1905 6.38606 14.5002 6.38606C13.8098 6.38606 13.2502 6.94571 13.2502 7.63606L13.2502 16.8512L11.1414 14.7425C10.6533 14.2543 9.8618 14.2543 9.37364 14.7425C8.88549 15.2306 8.88548 16.0221 9.37364 16.5102L13.6163 20.7529Z",
    fill: "#2EA7E5"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownCircle28);
export default __webpack_public_path__ + "static/media/arrow_down_circle_28.c4ee2ec1.svg";
export { ForwardRef as ReactComponent };